import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { Context } from "../App";
import { API } from "../conf";

export default function EgliseInfo(props) {
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [dons, setDons] = useState(0)
    const [versements, setVersements] = useState(0)
    const [depenses, setDepenses] = useState(0)
    const [comptes, setComptes] = useState(0)

    useEffect(()=>{
        if(!props.eglise?.number) return
        fetch(API.concat(`/eglises/${props.eglise.number}/db_infos`),{method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setDons(json.dons)
                    setVersements(json.versements)
                    setDepenses(json.depenses)
                    setComptes(json.comptes)
                }
                setLoad(false)
            }
        })
    },[props.eglise])

    return(
        <Box sx={{paddingInline:3, paddingBottom:3}}>
            <Typography variant="h5" align="center">Informations complémentaires DB</Typography>
            <Typography variant="h6" align="center" marginBottom={2}>{props.eglise.nom}</Typography>
            <Typography variant="body1">Nombre de dons : {dons}</Typography>
            <Typography variant="body1">Nombre de versements : {versements}</Typography>
            <Typography variant="body1">Nombre de dépenses : {depenses}</Typography>
            <Typography variant="body1">Nombre de comptes (hors compte d'initialisation) : {comptes}</Typography>
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}